import { InMemoryCacheConfig } from "@apollo/client";

export const cacheOptions: InMemoryCacheConfig = {
  typePolicies: {
    Promotions: {
      keyFields: ["name"],
    },
    // Viewer (me) and Riot are selected without an id; without merge a narrow query replaces the full object
    Viewer: {
      merge: true,
    },
    Riot: {
      merge: true,
    },
  },
};
